<div class="states-caption d-flex align-content-start flex-wrap">
  <div class="mr-2" *ngFor="let state of states">
    <div class="d-inline-flex align-items-center">
      <div class="pasi-states-caption-states entity-{{entity}} state_{{state.code}} mr-2"></div>
      <span class="states-caption_text">{{state.name | translate}}</span>
    </div>
  </div>
</div>
